import { render, staticRenderFns } from "./BrokerSideInfo.vue?vue&type=template&id=1b31af55"
import script from "./BrokerSideInfo.vue?vue&type=script&lang=js"
export * from "./BrokerSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports